import { dbFirestore } from "../../firestore";

import type { TicketRedeemGroup, WithId } from "../../firestore/types";

export const fetchTicketRedeemGroups = async (): Promise<
  WithId<TicketRedeemGroup>[]
> => {
  const snapshot = await dbFirestore.ticketRedeemGroups().get();
  return snapshot.docs.flatMap((doc) => {
    const data = doc.data();
    if (data === null) return [];
    return [{ ...data, id: doc.id }];
  });
};
